import { CustomerListPage } from '@/features/customer/pages/CustomerListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/customer/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["customer.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: CustomerListPage,
})
